import Categories from "components/Categories/Categories";

const CategoriesScreen = () => {
    return <Categories />;
};

export default CategoriesScreen;
